export default {
  sections: {
    latestResourcesSeen: 'Vistos recientemente',
    mostViewedResources: 'Recursos más visitados',
    lastFolders: 'Últimas carpetas agregadas',
    educationalPrograms: 'Programas educativos',
    lastPrograms: 'Programas educativos',
    resources: 'Últimos recursos agregados',
    mostViewedKimpleFolders: 'Explora las carpetas más vistas del mes',
    topics: 'Temáticas',
    sdgs: 'ODS',
    ephemeride: 'Próximas efemérides',
    foldersRecommended: 'Carpetas destacadas',
    latestResourcesAdded: 'Últimos recursos agregados',
    newestResources: 'Últimos recursos agregados'
  },
  seeMore: 'Ver más'
}

export const en = {
  sections: {
    latestResourcesSeen: 'Latest seen',
    mostViewedResources: 'Most seen resources',
    lastFolders: 'Latest added folders',
    educationalPrograms: 'Educational programs',
    lastPrograms: 'Educational programs',
    resources: 'Latest added resources',
    mostViewedKimpleFolders: 'Most viewed folders of the month',
    topics: 'Topics',
    sdgs: 'SDG',
    ephemeride: 'Next events',
    foldersRecommended: 'Featured folders',
    latestResourcesAdded: 'Latest added resources',
    newestResources: 'Latest added resources'
  },
  seeMore: 'See more'
}

export const ca = {
  sections: {
    latestResourcesSeen: 'Vists recentment',
    mostViewedResources: 'Recursos més visitats',
    lastFolders: 'Últimes carpetes agregades',
    educationalPrograms: 'Programes educatius',
    lastPrograms: 'Programes educatius',
    resources: 'Últims recursos agregats',
    mostViewedKimpleFolders: 'Explora les carpetes més vistes del mes',
    topics: 'Temàtiques',
    sdgs: 'ODS',
    ephemeride: 'Pròximes efemèrides',
    foldersRecommended: 'Carpetes destacades',
    latestResourcesAdded: 'Últims recursos agregats',
    newestResources: 'Últims recursos agregats'
  },
  seeMore: 'Veure més'
}
